import { render, staticRenderFns } from "./AppointmentStatusHistoryTable.vue?vue&type=template&id=62c70b3d"
import script from "./AppointmentStatusHistoryTable.vue?vue&type=script&lang=js"
export * from "./AppointmentStatusHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./AppointmentStatusHistoryTable.vue?vue&type=style&index=0&id=62c70b3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports